import { defineComponent as v, computed as s } from "vue";
import { isObject as y } from "lodash-es";
import C from "./td-longtail-vue-components19.js";
import { useLabeledInput as b } from "./td-longtail-vue-components258.js";
const h = /* @__PURE__ */ v({
  __name: "select-input",
  props: {
    label: { default: void 0 },
    labelClass: { default: void 0 },
    id: { default: void 0 },
    errorMessage: { default: void 0 },
    required: { type: Boolean },
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    showLabel: { type: Boolean },
    inlineLabel: { type: Boolean },
    large: { type: Boolean },
    medium: { type: Boolean },
    idPrefix: { default: void 0 },
    placeholder: { default: void 0 },
    inputClass: { default: void 0 },
    maxlength: { default: void 0 },
    inputProps: { default: void 0 },
    value: { default: void 0 },
    promptValue: { default: "" },
    prompt: { default: void 0 },
    hidePrompt: { type: Boolean, default: !1 },
    selectClass: { default: void 0 },
    autocomplete: { default: void 0 },
    name: { default: void 0 },
    options: null
  },
  emits: ["input", "select"],
  setup(p, { expose: d, emit: l }) {
    const e = p, { inputWrapperProps: i, inputFieldProps: r, focus: o } = b(e, l), f = s(() => e.selectClass ? e.selectClass : e.inputClass), a = s(() => e.options.map((t) => y(t) ? t : { label: t, value: t })), u = (t) => {
      const n = t.target?.value || null, c = a.value.find((m) => m.value === n);
      l("input", n), l("select", c);
    };
    return d({ focus: o, onInput: u }), { __sfc: !0, props: e, emits: l, inputWrapperProps: i, inputFieldProps: r, focus: o, inputOrCustomInputClass: f, sanitizedOptions: a, onInput: u, InputWrapper: C };
  }
});
export {
  h as default
};
